import { Http } from "../axios/interceptors";

export const allSuppliers = async (param) =>
  Http("GET", `/Suppliers/GetList?`, param);

export const getSupplier = async (id) =>
  Http("GET", `/Suppliers/Get?idSupplier=${id}`);

export const createOrEditSupplier = async (body, id = null) =>
  id
    ? Http("PUT", `/Suppliers/Update`, null, body)
    : Http("POST", "/Suppliers/Create", null, body);

export const deleteSupplier = async (id) =>
  Http("DELETE", `/Suppliers/Delete?idSupplier=${id}`);
